import { render, staticRenderFns } from "./addRoleModal.vue?vue&type=template&id=5c2b3f20&scoped=true"
import script from "./addRoleModal.vue?vue&type=script&lang=js"
export * from "./addRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b3f20",
  null
  
)

export default component.exports